module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-15.978bfd97.jpg";